import prettyBytes from "pretty-bytes";
import { prepDownloadManifestURL } from "../../apiUtils/downloadUrls";
import { formatIsoDateStr } from "../../utils";
import { FaFileDownload, FaTrashAlt } from "react-icons/fa";
import ViewDetailButton from "../viewDetailButton";
import Card from "./card";

const ManifestCard = ({ manifest, handleDeleteManifest }: { manifest: any; handleDeleteManifest: (publicId: string) => void }) => {
  return (
    <Card className="relative flex flex-col p-4">
      <div className="mb-4 flex items-start justify-between">
        <h1 className="text-2xl font-semibold text-blue-100">
          {manifest.name}
        </h1>
        <button
          title="Delete Manifest"
          className="text-gray-400 hover:text-red-600"
          onClick={async () => handleDeleteManifest(manifest.public_id)}
        >
          <FaTrashAlt />
        </button>
      </div>
      <p className="mb-4 text-gray-600">
        Data Size: {prettyBytes(manifest.size)}
      </p>
      <p className="mb-6 text-sm text-gray-500">
        Created on {formatIsoDateStr(manifest.created_dt)}
      </p>
      <div className="flex gap-4">
        <ViewDetailButton
          buttonText="View Assets"
          detailUrl={`/data/assets/search?manifestPublicIds=${manifest.public_id}`}
        />
        <a
          className="inline-block"
          href={prepDownloadManifestURL(manifest.public_id)}
        >
          <button className="ox-button px-2 py-1">
            <FaFileDownload className="mr-2 align-middle" />
            Download Manifest
          </button>
        </a>
      </div>
    </Card>
  );
};

export default ManifestCard;
